import { render, staticRenderFns } from "./MenuOpenIcon.vue?vue&type=template&id=116498f8&"
import script from "./MenuOpenIcon.vue?vue&type=script&lang=ts&"
export * from "./MenuOpenIcon.vue?vue&type=script&lang=ts&"
import style0 from "./MenuOpenIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports